module.exports = [
{ key: '1', name: '预交金' },
{ key: '2', name: '本行卡' },
{ key: '3', name: '他行卡' },
{ key: '4', name: '微信支付' },
{ key: '5', name: '支付宝支付' },
{ key: '6', name: '现金支付' },
{ key: '7', name: '银联支付' },
{ key: '8', name: '自助机上支付' },
{ key: '9', name: '社保卡支付' },
{ key: '1001', name: '市医保支付' },
{ key: '1002', name: '省医保支付' },
{ key: '1003', name: '铁路医保支付' }
    // '1':'预交金',
    // '2':'本行卡',
    // '3':'他行卡',
    // '4':'微信支付',
    // '5':'支付宝支付',
    // '6':'现金支付',
    // '7':'银联支付',
    // '8':'自助机上支付',
    // '9':'社保卡支付',
    // '1001':'市医保支付',
    // '1002':'省医保支付',
    // '1003':'铁路医保支付'
]


// WEBPACK FOOTER //
// ./src/config/dict/paychannel.js